import { useForm, useWatch } from 'react-hook-form';
import Button from '../../../../components/Button';
import Drawer from '../../../../components/Drawer';
import { StyledWrapper } from './style';
import { useInviteFromSettings } from '../../../../services/report.service';
import toast from 'react-hot-toast';
import { Select } from '../Select';
import { useGetWorkflowsFunds } from '../../../../services/workflow.services';
import Switch from 'react-switch';
import Checkbox from '../../../../components/Checkbox';
import SearchInput from '../SearchInput';
import { BadgeContainer, SelectBadge } from '../../../Project/Quarters/style';
import { useEffect, useState } from 'react';
import { TbChevronDown } from 'react-icons/tb';
import { getYearsForLastFiveYears } from '../../../../utils';

const periodOptions = ['Q1', 'Q2', 'Q3', 'Q4', 'H1', 'H2', 'Y1', 'X1', 'X2'];
const years = getYearsForLastFiveYears();

export const ApproveDrawer = ({ isOpen, onClose, refetch }) => {
  const inviteSettings = useInviteFromSettings();

  const [year, setYear] = useState('2026');
  const [quater, setQuater] = useState('Q1');
  const { data: workflowsFunds } = useGetWorkflowsFunds();
  const [projects, setProjects] = useState([]);
  const [term, setTerm] = useState('');
  const [expandedProjects, setExpandedProjects] = useState([]);

  const { control, register, handleSubmit, reset, setValue, watch } = useForm({
    defaultValues: {
      isActive: false
    }
  });

  const isActive = useWatch({
    control,
    name: 'isActive'
  });

  const aifms = useWatch({
    control,
    name: 'aifms',
    defaultValue: []
  });

  const onChangeActive = () => {
    setValue('isActive', !isActive);
  };

  useEffect(() => {
    if (workflowsFunds) {
      let _projects = workflowsFunds
        .filter(item => aifms.includes(item.id))
        .filter(item => item.periods.length > 0);
      if (term) {
        _projects = _projects.filter(item => item.name.toLowerCase().includes(term.toLowerCase()));
      }
      setProjects(_projects);
      setExpandedProjects(_projects.map(item => item.id));
    }
  }, [aifms, workflowsFunds, year, quater, term]);

  const onExpandProject = id => {
    if (expandedProjects.includes(id)) {
      setExpandedProjects(prev => prev.filter(val => val !== id));
    } else {
      setExpandedProjects(prev => [...prev, id]);
    }
  };

  const onExpandAllProjects = () => {
    if (expandedProjects.length === projects.length) {
      setExpandedProjects([]);
    } else {
      setExpandedProjects(projects.map(item => item.id));
    }
  };

  const onSwitchProject = value => {
    const _projects = JSON.parse(JSON.stringify(projects));
    _projects.forEach(project => {
      if (project.id === value.id) {
        const _periodIndex = project.periods.findIndex(
          value => value.year === +year && value.period === quater
        );
        if (project.periods[_periodIndex]) {
          const _selectedFunds = project.periods[_periodIndex].funds.filter(val => val.access);
          if (_selectedFunds.length === project.periods[_periodIndex].funds.length) {
            project.periods[_periodIndex].funds = project.periods[_periodIndex].funds.map(val => ({
              ...val,
              access: false
            }));
          } else {
            project.periods[_periodIndex].funds = project.periods[_periodIndex].funds.map(val => ({
              ...val,
              access: true
            }));
          }
        }
      }
    });

    setProjects(_projects);
  };

  const onSwitchFund = (projectId, value) => {
    const _projects = JSON.parse(JSON.stringify(projects));
    _projects.forEach(project => {
      if (project.id === projectId) {
        const _periodIndex = project.periods.findIndex(
          value => value.year === +year && value.period === quater
        );
        project.periods[_periodIndex].funds.forEach((fund, index) => {
          if (fund.id === value.id) {
            project.periods[_periodIndex].funds[index]['access'] = !value.access;
          }
        });
      }
    });

    setProjects(_projects);
  };

  const onSubmit = data => {
    const filteredProjects = projects
      .map(project => {
        const periodsWithAccess = project.periods
          .map(period => {
            const fundsWithAccess = period.funds.filter(fund => fund.access === true);
            if (fundsWithAccess.length > 0) {
              return {
                ...period,
                funds: fundsWithAccess
              };
            }
            return null;
          })
          .filter(Boolean);

        if (periodsWithAccess.length > 0) {
          return {
            id: project.id,
            name: project.name,
            periods: periodsWithAccess
          };
        }
        return null;
      })
      .filter(Boolean);
    inviteSettings.mutate(
      {
        body: [
          {
            name: data.name,
            email: data.email,
            workflows: filteredProjects.map(item => ({
              workflow_id: item.id,
              periods: item.periods.map(period => ({
                period_id: period.period_id,
                fund_ids: period.funds.map(fund => fund.id)
              }))
            })),
            is_aifm_included: true,
            is_approve_required: true
          }
        ]
      },
      {
        onSuccess: () => {
          onClose();
          refetch();
          toast.success('Invitations were successfully sent');
        }
      }
    );
  };

  return (
    <Drawer title="Reviewer Settings" open={isOpen} onClose={onClose} style={{ width: '604px' }}>
      <StyledWrapper onSubmit={handleSubmit(onSubmit)}>
        <div className="elements">
          <div className="input">
            <label>Reviewer Full Name</label>
            <input required {...register('name')} />
          </div>
          <div className="input">
            <label>Reviewer Email</label>
            <input type="email" required {...register('email')} />
          </div>
          <div className="input">
            <label>Project</label>
            <Select
              onChange={value => setValue('aifms', value)}
              value={aifms}
              options={workflowsFunds}
            />
          </div>
          <div className="switch">
            <Switch
              uncheckedIcon={false}
              width={42}
              height={20}
              checkedIcon={false}
              handleDiameter={15}
              onColor="#228BE6"
              offColor="#E9ECEF"
              onChange={onChangeActive}
              checked={isActive}
            />
            <label>Active Reviewer</label>
          </div>
        </div>

        {aifms.length > 0 && (
          <div className="search-bar">
            <div className="top-bar">
              <p className="title">Project and Fund Access</p>
              <div className="expand">
                <p>Expand All</p>
                <Checkbox
                  checked={expandedProjects.length === projects.length}
                  onChange={() => onExpandAllProjects()}
                />
              </div>
            </div>
            <SearchInput value={term} onChange={value => setTerm(value)} fullWidth />
          </div>
        )}

        {aifms.length > 0 && (
          <div className="periods">
            <div className="element">
              <label>Select Period</label>
              <BadgeContainer>
                {periodOptions.map((value, yId) => (
                  <SelectBadge
                    key={yId + 'period'}
                    active={quater === value}
                    onClick={() => setQuater(value)}
                    type="button"
                  >
                    {value}
                  </SelectBadge>
                ))}
              </BadgeContainer>
            </div>

            <div className="element">
              <label>Select Year</label>

              <BadgeContainer>
                {years.map((value, yId) => (
                  <SelectBadge
                    key={yId}
                    active={year === value}
                    onClick={() => setYear(value)}
                    type="button"
                  >
                    {value}
                  </SelectBadge>
                ))}
              </BadgeContainer>
            </div>
          </div>
        )}

        <div className="funds-container">
          {projects.map(item => {
            const _period = item.periods.find(
              value => value.year === +year && value.period === quater
            );
            return (
              _period && (
                <div className="funds" key={item.id}>
                  <div className="header">
                    <p>Project Name</p>
                    <p>Access</p>
                  </div>
                  <div className="body">
                    <div className="fund-name">
                      <div className="name">
                        <TbChevronDown onClick={() => onExpandProject(item.id)} />
                        {item.name}
                      </div>
                      <div className="switch">
                        <Switch
                          uncheckedIcon={false}
                          width={42}
                          height={20}
                          checkedIcon={false}
                          handleDiameter={15}
                          onColor="#228BE6"
                          offColor="#E9ECEF"
                          onChange={() => onSwitchProject(item)}
                          checked={
                            _period &&
                            _period.funds.filter(val => val.access).length === _period.funds.length
                          }
                        />
                      </div>
                    </div>
                    {expandedProjects.includes(item.id) &&
                      _period &&
                      _period.funds.map(fund => (
                        <div className="period" key={fund.id}>
                          <p>{fund.name}</p>
                          <div className="switch">
                            <Switch
                              uncheckedIcon={false}
                              width={42}
                              height={20}
                              checkedIcon={false}
                              handleDiameter={15}
                              onColor="#228BE6"
                              offColor="#E9ECEF"
                              onChange={() => onSwitchFund(item.id, fund)}
                              checked={!!fund.access}
                            />
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
              )
            );
          })}
        </div>

        <div className="buttons">
          <Button
            disabled={aifms.length === 0 || !watch('name') || !watch('email')}
            isLoading={inviteSettings.isLoading}
            type="submit"
            size="sm"
          >
            Send
          </Button>
        </div>
      </StyledWrapper>
    </Drawer>
  );
};
